import { proxy, arrayProxy, fnProxy, fnArrayProxy } from "snek-query";
export var OAuthProvider;
(function (OAuthProvider) {
    OAuthProvider["google"] = "google";
    OAuthProvider["azure"] = "azure";
})(OAuthProvider || (OAuthProvider = {}));
export var Language;
(function (Language) {
    Language["EN"] = "EN";
    Language["DE"] = "DE";
})(Language || (Language = {}));
export var Privacy;
(function (Privacy) {
    Privacy["PUBLIC"] = "PUBLIC";
    Privacy["PRIVATE"] = "PRIVATE";
    Privacy["FRIENDS"] = "FRIENDS";
})(Privacy || (Privacy = {}));
export var LanguageInputInput;
(function (LanguageInputInput) {
    LanguageInputInput["EN"] = "EN";
    LanguageInputInput["DE"] = "DE";
})(LanguageInputInput || (LanguageInputInput = {}));
export var MOST_RECENT_MOST_STARREDInputInput;
(function (MOST_RECENT_MOST_STARREDInputInput) {
    MOST_RECENT_MOST_STARREDInputInput["MOST_RECENT"] = "MOST_RECENT";
    MOST_RECENT_MOST_STARREDInputInput["MOST_STARRED"] = "MOST_STARRED";
})(MOST_RECENT_MOST_STARREDInputInput || (MOST_RECENT_MOST_STARREDInputInput = {}));
export var PrivacyInputInput;
(function (PrivacyInputInput) {
    PrivacyInputInput["PUBLIC"] = "PUBLIC";
    PrivacyInputInput["PRIVATE"] = "PRIVATE";
    PrivacyInputInput["FRIENDS"] = "FRIENDS";
})(PrivacyInputInput || (PrivacyInputInput = {}));
export var OAuthProviderInputInput;
(function (OAuthProviderInputInput) {
    OAuthProviderInputInput["google"] = "google";
    OAuthProviderInputInput["azure"] = "azure";
})(OAuthProviderInputInput || (OAuthProviderInputInput = {}));
export var EmailAddressTypeInputInput;
(function (EmailAddressTypeInputInput) {
    EmailAddressTypeInputInput["EMAIL_ADDRESS"] = "EMAIL_ADDRESS";
    EmailAddressTypeInputInput["EMAIL_ID"] = "EMAIL_ID";
    EmailAddressTypeInputInput["USER_ID"] = "USER_ID";
})(EmailAddressTypeInputInput || (EmailAddressTypeInputInput = {}));
export class Query {
    constructor() { this.__typename = ""; this.user = fnProxy(ObjectAndUser); this.allUser = fnArrayProxy(User); this.userMe = proxy(User); this.resource = fnProxy(Resource); this.shopifyAllProductId = () => []; this.socialPost = fnProxy(Post); this.allSocialPost = fnProxy(Connection_1); this.allSocialPostTrending = fnProxy(Connection_1); this.version = ""; }
}
export class ObjectAndUser {
    constructor() { this.__typename = ""; this.isActive = false; this.id = ""; this.username = ""; this.resourceId = ""; this.accountId = ""; this.isAdmin = false; this.createdAt = ""; this.updatedAt = ""; this.roles = arrayProxy(Roles); this.primaryEmailAddress = ""; this.email = fnProxy(Email); this.emails = arrayProxy(Email); this.account = proxy(Account); this.resource = proxy(Resource_1); this.tokens = arrayProxy(Token); this.details = proxy(Details); this.externalCredential = fnProxy(ExternalCredential); this.externalCredentials = arrayProxy(ExternalCredential); this.profile = proxy(Profile); }
}
export class Roles {
    constructor() { this.__typename = ""; this.id = ""; this.description = ""; this.resourceId = ""; this.createdAt = ""; this.updatedAt = ""; }
}
export class Email {
    constructor() { this.__typename = ""; this.id = ""; this.emailAddress = ""; this.resourceId = ""; this.isPrimary = false; this.isVerified = false; this.userId = null; this.createdAt = ""; this.updatedAt = ""; this.config = proxy(EmailConfig); }
}
export class EmailConfig {
    constructor() { this.__typename = ""; this.id = ""; this.isEnabled = false; this.externalCredential = proxy(ExternalCredential); }
}
export class ExternalCredential {
    constructor() { this.__typename = ""; this.id = ""; this.smtp = proxy(SMTPCredential); this.oauth = proxy(OAuthCredential); }
}
export class SMTPCredential {
    constructor() { this.__typename = ""; this.host = ""; this.port = null; this.username = ""; this.password = ""; this.secure = false; }
}
export class OAuthCredential {
    constructor() { this.__typename = ""; this.provider = null; this.accessToken = ""; this.refreshToken = ""; }
}
export class Account {
    constructor() { this.__typename = ""; this.id = ""; this.users = arrayProxy(User); }
}
export class User {
    constructor() { this.__typename = ""; this.isActive = false; this.id = ""; this.username = ""; this.resourceId = ""; this.accountId = ""; this.isAdmin = false; this.createdAt = ""; this.updatedAt = ""; this.roles = arrayProxy(Roles); this.primaryEmailAddress = ""; this.email = fnProxy(Email); this.emails = arrayProxy(Email); this.account = proxy(Account); this.resource = proxy(Resource_1); this.tokens = arrayProxy(Token); this.details = proxy(Details); this.externalCredential = fnProxy(ExternalCredential); this.externalCredentials = arrayProxy(ExternalCredential); }
}
export class Resource_1 {
    constructor() { this.__typename = ""; this.id = ""; this.name = ""; this.createdAt = ""; this.updatedAt = ""; this.roles = arrayProxy(Roles); this.users = arrayProxy(User); this.config = proxy(GenericObject); this.secrets = arrayProxy(SecretObject); this.secret = fnProxy(SecretObject); }
}
export class GenericObject {
    constructor() { this.__typename = ""; this.id = ""; this.value = null; this.tag = null; this.expiresAt = null; }
}
export class SecretObject {
    constructor() { this.__typename = ""; this.name = ""; this.value = null; this.expiresAt = null; }
}
export class Token {
    constructor() { this.__typename = ""; this.id = ""; this.name = ""; this.expiresAt = null; }
}
export class Details {
    constructor() { this.__typename = ""; this.firstName = null; this.lastName = null; this.avatarURL = null; }
}
export class Profile {
    constructor() { this.__typename = ""; this.id = ""; this.resourceId = ""; this.bio = null; this.createdAt = ""; this.updatedAt = ""; this.language = null; this.user = proxy(User_1); this.posts = fnProxy(Connection_1); this.starredPosts = fnProxy(Connection_1_2); this.stars = fnProxy(Connection_1_2_3); this.followers = fnProxy(Connection_1_2_3_4); this.following = fnProxy(Connection_1_2_3_4_5); this.activity = fnProxy(Connection_1_2_3_4_5_6); this.views = null; }
}
export class User_1 {
    constructor() { this.__typename = ""; this.details = proxy(Details_1); this.username = ""; this.primaryEmailAddress = ""; }
}
export class Details_1 {
    constructor() { this.__typename = ""; this.firstName = null; this.lastName = null; this.avatarURL = null; }
}
export class Connection_1 {
    constructor() { this.__typename = ""; this.nodes = arrayProxy(Post); this.edges = arrayProxy(Edge); this.pageInfo = proxy(PageInfo); this.totalCount = null; }
}
export class Post {
    constructor() { this.__typename = ""; this.id = ""; this.slug = ""; this.title = ""; this.avatarURL = null; this.summary = null; this.content = null; this.profileId = ""; this.createdAt = ""; this.updatedAt = ""; this.privacy = null; this.language = null; this.matchingQuery = null; this.profile = proxy(Profile); this.stars = fnProxy(Connection_1_2_3_4_5_6_7); this.views = null; }
}
export class Connection_1_2_3_4_5_6_7 {
    constructor() { this.__typename = ""; this.nodes = arrayProxy(Nodes); this.edges = arrayProxy(Edge_1); this.pageInfo = proxy(PageInfo); this.totalCount = null; }
}
export class Nodes {
    constructor() { this.__typename = ""; this.id = ""; this.profile = proxy(Profile); this.createdAt = ""; }
}
export class Edge_1 {
    constructor() { this.__typename = ""; this.cursor = ""; this.node = proxy(Nodes); }
}
export class PageInfo {
    constructor() { this.__typename = ""; this.hasNextPage = false; this.hasPreviousPage = false; this.startCursor = null; this.endCursor = null; }
}
export class Edge {
    constructor() { this.__typename = ""; this.cursor = ""; this.node = proxy(Post); }
}
export class Connection_1_2 {
    constructor() { this.__typename = ""; this.nodes = arrayProxy(Nodes_1); this.edges = arrayProxy(Edge_1_2); this.pageInfo = proxy(PageInfo); this.totalCount = null; }
}
export class Nodes_1 {
    constructor() { this.__typename = ""; this.id = ""; this.post = proxy(Post); this.createdAt = ""; }
}
export class Edge_1_2 {
    constructor() { this.__typename = ""; this.cursor = ""; this.node = proxy(Nodes_1); }
}
export class Connection_1_2_3 {
    constructor() { this.__typename = ""; this.nodes = arrayProxy(Nodes_1_2); this.edges = arrayProxy(Edge_1_2_3); this.pageInfo = proxy(PageInfo); this.totalCount = null; }
}
export class Nodes_1_2 {
    constructor() { this.__typename = ""; this.id = ""; this.post = proxy(Post); this.createdAt = ""; }
}
export class Edge_1_2_3 {
    constructor() { this.__typename = ""; this.cursor = ""; this.node = proxy(Nodes_1_2); }
}
export class Connection_1_2_3_4 {
    constructor() { this.__typename = ""; this.nodes = arrayProxy(Nodes_1_2_3); this.edges = arrayProxy(Edge_1_2_3_4); this.pageInfo = proxy(PageInfo); this.totalCount = null; }
}
export class Nodes_1_2_3 {
    constructor() { this.__typename = ""; this.id = ""; this.follower = proxy(Profile); this.createdAt = ""; }
}
export class Edge_1_2_3_4 {
    constructor() { this.__typename = ""; this.cursor = ""; this.node = proxy(Nodes_1_2_3); }
}
export class Connection_1_2_3_4_5 {
    constructor() { this.__typename = ""; this.nodes = arrayProxy(Nodes_1_2_3_4); this.edges = arrayProxy(Edge_1_2_3_4_5); this.pageInfo = proxy(PageInfo); this.totalCount = null; }
}
export class Nodes_1_2_3_4 {
    constructor() { this.__typename = ""; this.id = ""; this.followed = proxy(Profile); this.createdAt = ""; }
}
export class Edge_1_2_3_4_5 {
    constructor() { this.__typename = ""; this.cursor = ""; this.node = proxy(Nodes_1_2_3_4); }
}
export class Connection_1_2_3_4_5_6 {
    constructor() { this.__typename = ""; this.nodes = arrayProxy(Nodes_1_2_3_4_5); this.edges = arrayProxy(Edge_1_2_3_4_5_6); this.pageInfo = proxy(PageInfo); this.totalCount = null; }
}
export class Nodes_1_2_3_4_5 {
    constructor() { this.__typename = ""; this.id = ""; this.createdAt = ""; this.type = ""; this.post = proxy(Post); this.follow = proxy(Follow); }
}
export class Follow {
    constructor() { this.__typename = ""; this.createdAt = ""; this.followed = proxy(Profile); }
}
export class Edge_1_2_3_4_5_6 {
    constructor() { this.__typename = ""; this.cursor = ""; this.node = proxy(Nodes_1_2_3_4_5); }
}
export class Resource {
    constructor() { this.__typename = ""; this.id = ""; this.name = ""; this.config = null; this.secret = fnProxy(Secret); }
}
export class Secret {
    constructor() { this.__typename = ""; this.name = ""; this.value = null; }
}
export class Mutation {
    constructor() { this.__typename = ""; this.passwordReset = () => false; this.passwordResetConfirm = () => false; this.userSignIn = fnProxy(UserSignIn); this.userSignOut = () => null; this.userRefresh = fnProxy(UserRefresh); this.userRegister = fnProxy(User); this.userCreate = fnProxy(UserCreate); this.userCreateConfirm = fnProxy(User); this.userUpdate = fnProxy(User); this.userDelete = () => false; this.userEmailCreate = fnProxy(UserEmail); this.userEmailConfirm = fnProxy(UserEmailConfirm); this.userEmailConfirmationResend = fnProxy(Email); this.userEmailUpdate = fnProxy(UserEmail); this.userEmailDelete = () => false; this.userExternalCredentialCreate = () => ""; this.userTokenCreate = () => ""; this.jaenPublish = () => ""; this.shopifyProductCreate = () => ""; this.shopifyProductUpdate = () => ""; this.shopifyProductDelete = () => ""; this.mailpressMailSchedule = () => ""; this.socialProfileUpdate = fnProxy(Profile); this.socialProfileFollow = fnProxy(ProfileFollow); this.socialProfileUnfollow = fnProxy(ProfileFollow); this.socialPostCreate = fnProxy(Post); this.socialPostUpdate = fnProxy(Post); this.socialPostDelete = () => false; this.socialPostStar = fnProxy(PostStar); this.socialPostUnstar = fnProxy(PostStar); }
}
export class UserSignIn {
    constructor() { this.__typename = ""; this.tokenPair = proxy(TokenPair); this.user = proxy(ObjectAndUser); }
}
export class TokenPair {
    constructor() { this.__typename = ""; this.id = ""; this.accessToken = ""; this.refreshToken = ""; this.headers = null; }
}
export class UserRefresh {
    constructor() { this.__typename = ""; this.tokenPair = proxy(TokenPair_1); this.me = proxy(User); }
}
export class TokenPair_1 {
    constructor() { this.__typename = ""; this.accessToken = ""; this.refreshToken = ""; }
}
export class UserCreate {
    constructor() { this.__typename = ""; this.profile = proxy(Profile); this.isActive = false; this.id = ""; this.username = ""; this.resourceId = ""; this.accountId = ""; this.isAdmin = false; this.createdAt = ""; this.updatedAt = ""; this.roles = arrayProxy(Roles); this.primaryEmailAddress = ""; this.email = fnProxy(Email); this.emails = arrayProxy(Email); this.account = proxy(Account); this.resource = proxy(Resource_1); this.tokens = arrayProxy(Token); this.details = proxy(Details); this.externalCredential = fnProxy(ExternalCredential); this.externalCredentials = arrayProxy(ExternalCredential); }
}
export class UserEmail {
    constructor() { this.__typename = ""; this.id = ""; this.emailAddress = ""; this.isPrimary = false; this.isVerified = false; this.config = proxy(EmailConfig_1); }
}
export class EmailConfig_1 {
    constructor() { this.__typename = ""; this.id = ""; this.isEnabled = false; this.externalCredential = proxy(ExternalCredential_1); }
}
export class ExternalCredential_1 {
    constructor() { this.__typename = ""; this.smtp = proxy(SMTPCredential); this.oauth = proxy(OAuthCredential); }
}
export class UserEmailConfirm {
    constructor() { this.__typename = ""; this.id = ""; this.isVerified = false; }
}
export class ProfileFollow {
    constructor() { this.__typename = ""; this.id = ""; this.followerId = ""; this.followedId = ""; this.createdAt = ""; }
}
export class PostStar {
    constructor() { this.__typename = ""; this.id = ""; this.postId = ""; this.profileId = ""; this.createdAt = ""; }
}
